// AI Generated File
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'statistics-distribution',
    templateUrl: './statistics-distribution.component.html',
    standalone: false,
})
export class StatisticsDistributionComponent implements OnInit {
    @Input() visits: number = 0;
    @Input() totalVisits: number = 0;
    @Input() removeNumber?: boolean;

    ngOnInit (): void {
        this.visits = parseInt(String(this.visits));
        this.totalVisits = parseInt(String(this.totalVisits));
    }
}
